module.exports = __webpack_public_path__ + "assets/img/Type E (78).20a73688.jpg";